import { send } from 'server';

export const linkWallet = ({
    system,
    pin
}) => send({
    ID: 35820,
    responses: [35821, 35822],
    description: 'Link Wallet',
    system,
    pin
});

export const getPlayerTags = ({
    tagNames
}) => send({
    ID: 35547,
    responses: [35548, 35549],
    description: 'Get Player Tags Request',
    tagName: tagNames.join(',')
});

export const getPlayerInfo = ({
    requestedPlayerData
}) => send({
    ID: 31082,
    responses: [31083, 31084],
    description: 'Get Player Info',
    requestType: 'marked',
    requestedPlayerData,
    returnContactPreferences: false
});
